var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHeart = function SvgHeart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 110 120"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#7B4EF8",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M29.5 18C15.417 18 4 29.5 4 43.687 4 65 32 93 55.927 103 80 93 106 65 106 43.687 106 29.5 94.583 18 80.5 18S57 29.5 55 43.687C53 29.5 43.583 18 29.5 18Z"
  })));
};
export default SvgHeart;